import styled from 'styled-components';
import { Body } from '../../../components/Typography';

export const ErrorMessage = styled(Body)`
  font-size: ${({ theme }) => theme.font.size.s};
  color: ${({ theme }) => theme.palette.primary.red};
`;
